module.exports = __webpack_public_path__ + "static/media/execution_absence.fa97681d.jpeg";